export default phone => {
  return phone.length === 10
    ? `(${phone.substr(0, 3)}) ${phone.substr(3, 3)}–${phone.substr(6)}`
    : phone;
};
